import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {environment} from '../../../../../../../environments/environment';
import {RequestMethod, RestService} from '../../../../../../shared/services/rest.service';
import {ResponseSnackbarService} from '../../../../../../shared/services/response-snackbar.service';
import {Actions, ApiEndpoints} from '../../../../../../shared/constants/ApiEndpoints';
import {GeneralConstant} from '../../../../../../shared/constants/GeneralConstant';
import {ConfirmModalComponent} from '../../../../../shared/modules/confirm-modal/confirm-modal.component';
import {PermissionLink} from '../../../../../../shared/permission/PermissionLink';


@Component({
  selector: 'app-stripe-card-item',
  templateUrl: './stripe-card-item.component.html',
  styleUrls: ['./stripe-card-item.component.scss', '../stripe-utils.component.scss']
})
export class StripeCardItemComponent implements OnInit {
  @Input() card: any;
  @Input() defaultCard: string;
  @Input() cardOptions: {
    cardIndex?: number,
    totalCards?: number
  };

  canUserCreateAndUpdateCard = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.UPDATE);
  canUserDeleteCard = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.DELETE);
  @Output() stripeItemChanged = new EventEmitter<boolean>();
  @Input() permissions?;

  public cardBrand: string;

  constructor(private restService: RestService,
              public dialog: MatDialog,
              private snackBar: ResponseSnackbarService) {
  }

  ngOnInit() {
    this.setCardBrand();
  }

  /*
  ** Set Card Default
   */
  onSetCardDefault(): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/set_default`;

    this.restService.restRequest(
      RequestMethod.PUT,
      URL,
      {
        body: {
          card: this.card.id
        }
      }
    ).subscribe(response => {
      this.onShowSnackBar(response);
    });
  }

  /*
  ** Open Delete Modal for Deleting Card
   */
  onOpenDeleteModalCard(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {name: 'payment method: ********' + this.card.last4}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.delete) {
        this.removeCard();
      }
    });
  }

  /*
  ** Remove Card
   */
  removeCard(): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.DELETE}/card`;

    this.restService.restRequest(
      RequestMethod.DELETE,
      URL,
      {
        body: {
          card: this.card.id
        }
      }
    ).subscribe(response => {
      this.onShowSnackBar(response);
    });
  }

  /**
   * Set card image.
   */
  private setCardBrand(): void {
    const PATH = 'assets/images/cards/';

    if (this.card.funding === 'us_bank_account' || this.card.type === 'us_bank_account') {
      this.cardBrand = PATH + 'bank_1.png';
      return;
    }

    switch (this.card.brand) {
      case 'visa': {
        this.cardBrand = PATH + 'visa.svg';
        break;
      }
      case 'mastercard': {
        this.cardBrand = PATH + 'mastercard.svg';
        break;
      }
      case 'discover': {
        this.cardBrand = PATH + 'discover.svg';
        break;
      }
      case 'unionpay': {
        this.cardBrand = PATH + 'unionpay.svg';
        break;
      }
      case 'jcb': {
        this.cardBrand = PATH + 'jcb.svg';
        break;
      }
      case 'diners': {
        this.cardBrand = PATH + 'diners.svg';
        break;
      }
      case 'American Express': {
        this.cardBrand = PATH + 'bank_1.png';
        break;
      }
      case 'amex': {
        this.cardBrand = PATH + 'amex.svg';
        break;
      }
    }
  }

  /*
  ** - Show SnackBar
  ** - Notify Parent for changes
   */
  private onShowSnackBar(response): void {
    const message = response.message;

    if (response && response.success) {
      this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
      this.stripeItemChanged.emit(true);
    } else {
      this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
    }
  }
}
